import { InjectionToken } from '@angular/core';

/**
 * Represents a dependency injection token used to determine whether the current platform
 * is a native platform (e.g., React Native, NativeScript) for Firebase.
 *
 * This token can be used in Angular's dependency injection system to provide
 * platform-specific behavior based on whether the environment is a native platform.
 *
 * Value type: boolean
 */
export const FIREBASE_IS_NATIVE_PLATFORM_IT = new InjectionToken<boolean>('isNativePlatformInjectionToken');
